import ModalComponent from '../../../components/ModalComponent';
import DeviceReverseConnectionStreamComponent from '../../../components/DeviceReverseConnectionStreamComponent';
import { IDeviceStreamModalProps } from './types';
import { getToken } from '../../../services/DefaultService';
import DeviceDirectConnectionStreamComponent from '../../../components/DeviceDirectConnectionStreamComponent';
import WebRTCPlayerOvenMedia from '../../../components/WebRTCPlayerOvenMedia';

interface DeviceStreamModalProps {
  onClose: () => void;
  deviceStream: IDeviceStreamModalProps;
  isDirectConnection: boolean;
}

const DeviceStreamModal = ({
  deviceStream,
  onClose,
  isDirectConnection,
}: DeviceStreamModalProps) => {
  const renderDeviceStream = () => {
    const token = getToken();
    if (token) {
      if (isDirectConnection) {
        return (
          <DeviceDirectConnectionStreamComponent
            deviceId={deviceStream.deviceId}
            deviceName={deviceStream.deviceName}
            isEnableVideo={deviceStream.isOnline}
          />
        );
      }
      return (
        <DeviceReverseConnectionStreamComponent
          deviceId={deviceStream.deviceId}
          isEnableVideo={deviceStream.isOnline}
          token={atob(token)}
        />
      );
    }
    return <></>;
  };
  return (
    <ModalComponent
      onClose={onClose}
      isOpen={deviceStream.isVisible}
      title={`Transmissão ao vivo do dispositivo ${deviceStream.deviceName}`}
    >
      {renderDeviceStream()}
    </ModalComponent>
  );
};

export default DeviceStreamModal;
